import axios from 'axios'
import Fuse from 'fuse.js'
import swal from 'sweetalert2'
import showSwalAlert from 'src/util/alerts'
import { Alert, Badge, Button, Dialog, Tag, Table, TableColumn, Select, Option } from 'element-ui'
import {Pagination as LPagination} from 'src/components/index'

const mixinMasters = {
    components:{
        LPagination,
        [Alert.name]: Alert,
        [Badge.name]: Badge,
        [Button.name]: Button,
        [Dialog.name]: Dialog,
        [Select.name]: Select,
        [Option.name]: Option,
        [Tag.name]: Tag,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn
    },
    data () {
        return {
            title: null,
            errorAlert: null,
            disabledField: false,
            rowData: null,
            selectClass: 'select-primary',
            searchQuery: '',
            tableData: [],
            fuseSearch: null,
            modals: {
                read: false,
            },
            pagination: {
                perPage: 5,
                currentPage: 1,
                perPageOptions: [5, 10, 25, 50],
                total: 0
            }
        }
    },
    computed: {
        pagedData () {
            return this.tableData.slice(this.from, this.to)
        },
        /***
         * Searches through table data and returns a paginated array.
         * Note that this should not be used for table with a lot of data as it might be slow!
         * Do the search and the pagination on the server and display the data retrieved from server instead.
         * @returns {computed.pagedData}
         */
        queriedData () {
            let result = this.tableData
            if (this.searchQuery !== '') {
                result = this.fuseSearch.search(this.searchQuery)
                this.pagination.total = result.length
            }
            return result.slice(this.from, this.to)
        },
        to () {
            let highBound = this.from + this.pagination.perPage
            if (this.total < highBound) {
                highBound = this.total
            }
            return highBound
        },
        from () {
            return this.pagination.perPage * (this.pagination.currentPage - 1)
        },
        total () {
            this.pagination.total = this.tableData.length
            return this.tableData.length
        }
    },
    methods: {
        /**
        * este metodo se encarga de hacer la peticion a la api
        * para obtener todos los maestros registrados en el sistema
        * @return {Promise}
        */
        async getMasters(route) {
            return await axios.get( 'auth/'+route)
        },

        /**
        * este metodo se encarga de hacer la peticion a la api
        * para almacenar un modulo nuevo en la base de datos
        * @param  {JSON}
        * @return {Promise}
        */
        async saveMaster(data) {
            return await axios.post( 'auth/'+data.route, data)
        },

        /**
        * este metodo se encarga de hacer la peticion a la api
        * para actualizar un modulo existente en la base de datos
        * @param  {JSON}
        * @return {Promise}
        */
        async updateMaster(data) {
            return await axios.put( 'auth/'+data.route+'/'+data.id, data)
        },

        /**
        * este metodo se encarga de hacer la peticion a la api
        * para eliminar un modulo existente en la base de datos
        * @param  {JSON}
        * @return {Promise}
        */
        async destroyMaster(data) {
            if(data.logistic_center){
                return await axios.delete( 'auth/'+data.route+'/'+data.id+'?logistic_center='+data.logistic_center)
            }
            return await axios.delete( 'auth/'+data.route+'/'+data.id)
        },

        /**
        * este metodo se encarga de hacer la peticion a la api
        * para obtener el archivo en pdf con todos los maestros,
        * ademas crea un enlace y lo ejecuta para empezar la descarga
        * @return {VoidFunction}
        */
        exportPDF(data) {
            showSwalAlert(
                'Espere mientras el archivo en formato PDF se descarga.', 
                null, null, null, null, swal
            )
            return axios({
                url: '/auth/'+data.route,
                method: 'GET',
                responseType: 'blob',
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', data.name_file);
                document.body.appendChild(link);
                link.click();
                swal.close()
            });
        },

        /**
        * este metodo se encarga de hacer la peticion a la api
        * para obtener el archivo en excel con todos los maestros,
        * ademas crea un enlace y lo ejecuta para empezar la descarga
        * @return {VoidFunction}
        */
        exportExcel(data) {
            showSwalAlert(
                'Espere mientras el archivo en formato Excel se descarga.', 
                null, null, null, null, swal
            )
            return axios({
                url: '/auth/'+data.route,
                method: 'GET',
                responseType: 'blob',
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', data.name_file);
                document.body.appendChild(link);
                link.click();
                swal.close()
            });
        },      
        modifyTable(type, id, response, modal=null, icon=null){
            let index = this.tableData.findIndex((tableRow) => tableRow.id === id);
            switch(type){
                case 0:
                    this.tableData.push(response.data.data)
                    this.closeModal('create')
                    this.$emit('showNotification', `<span>${response.data.message}</span>`, 'success', 'nc-simple-add') 
                    break
                case 1:
                    this.$set(this.tableData, index, response.data.data)            
                    this.closeModal('create')
                    this.$emit('showNotification', `<span>${response.data.message}</span>`, 'warning', 'nc-settings-tool-66')   
                    break
                case 2: 
                    if (index >= 0) this.tableData.splice(index, 1)
                    this.$emit('showNotification', `<span>${response.data.message}</span>`, 'danger', 'nc-simple-remove')   
                    break
                case 3:
                    this.$set(this.tableData, index, response.data.data)            
                    if(modal) this.closeModal(modal)
                    this.$emit('showNotification', `<span>${response.data.message}</span>`, 'warning', 'nc-settings-90')   
                    break 
                case 4:
                    if(modal) this.closeModal(modal)
                    this.$emit('showNotification', `<span>${response.data.message}</span>`, 'warning', icon)   
                    break         
            }
        },     
        searchFuse(keys){
            this.fuseSearch = new Fuse(this.tableData, {keys: keys})
            this.$emit('cotentLoading')
        },              
        getError(fieldName){
            return this.errors.first(fieldName)
        },
        openModal (name) {
            this.modals[name] = true
        },        
        closeModal(name){
            this.modals[name] = false
        },
        exportToPDF (route, name){
            let data = {}
            data.route = route
            data.name_file = name
            this.exportPDF(data).then(() => {
                this.showDownloadNotification()
            })
        },
        exportToExcel (route, name){
            let data = {}
            data.route = route
            data.name_file = name
            this.exportExcel(data).then(() => {
                this.showDownloadNotification()
            })
        },      
        showDownloadNotification(){
            this.$emit('showNotification', `<span> Archivo descargado correctamente </span>`, 'info', 'nc-cloud-download-93')   
        }      
    },
 }

export default mixinMasters